import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteGeographyFailed, deleteGeographySuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* deleteGeography(action) {
  try {
    const url = `${BACKEND_MDS_URL}/geography/geographies/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteGeographySuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteGeographyFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteGeographyFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
